import { API } from "./api";

function base64UrlToUint8Array(value) {
  const padded = value + "=".repeat((4 - (value.length % 4)) % 4);
  const binary = atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(binary, (char) => char.charCodeAt(0));
}

export async function getPushStatus() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return { enabled: false, supported: false };
  const { data } = await API.get("/push/status");
  return { ...data, supported: true };
}

export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("This browser does not support Web Push");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission was not granted");
  await navigator.serviceWorker.register("/service-worker.js");
  const registration = await navigator.serviceWorker.ready;
  const { data } = await API.get("/push/vapid-public-key");
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: base64UrlToUint8Array(data.publicKey),
    });
  }
  await API.post("/push/subscribe", subscription.toJSON());
  return subscription;
}

export async function disablePush() {
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;
  await API.delete("/push/unsubscribe", { data: { endpoint: subscription.endpoint } });
  await subscription.unsubscribe();
}
